'use strict';


import { 
    // tabTrapping, 
    // jquerySlider,
    jqueryTabTrapping,
    moveImageToBg, 
    effectOnScroll, 
    ncrSlider,
    ncrIcons, 
    utils, 
    elementResizer, 
    moveElementAround,
    clickableDiv
  } from '@ncr-digital-banking/web-js-lib';
  import { customIcons } from './icons.js';


  window.jqueryTabTrapping = jqueryTabTrapping;
  window.moveImageToBg = moveImageToBg;
  window.effectOnScroll = effectOnScroll;
  window.ncrIcons = ncrIcons;
  window.utils = utils 
  window.elementResizer = elementResizer;
  window.moveElementAround = moveElementAround; 
  window.clickableDiv = clickableDiv;
  window.customIcons = customIcons;
  window.ncrSlider = ncrSlider;